/* ═══════════════════════════════════════════════════════════
   Script comune alle pagine interne (Scopri, Contatti,
   Distributori, Privacy, Condizioni).
   La home ha il suo main.js, più grosso: qui serve solo
   la barra, il menu del telefono, le comparse e i moduli.
   ═══════════════════════════════════════════════════════════ */
(() => {
  'use strict';

  const REDOTTO = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const bar = document.getElementById('nav');
  const prog = document.getElementById('barProg');

  /* ── testo che compare parola per parola ── */
  if (!REDOTTO) {
    document.querySelectorAll('.split').forEach((el) => {
      if (el.querySelector('.w')) return;
      const frammenti = [...el.childNodes];
      el.innerHTML = '';
      frammenti.forEach((n) => {
        if (n.nodeType === 3) {
          n.textContent.split(/(\s+)/).forEach((tok) => {
            if (!tok.trim()) { el.appendChild(document.createTextNode(tok)); return; }
            const w = document.createElement('span');
            w.className = 'w';
            const i = document.createElement('i');
            i.textContent = tok;
            w.appendChild(i);
            el.appendChild(w);
          });
        } else if (n.nodeType === 1) {
          const clone = n.cloneNode(false);
          n.textContent.split(/(\s+)/).forEach((tok) => {
            if (!tok.trim()) { clone.appendChild(document.createTextNode(tok)); return; }
            const w = document.createElement('span');
            w.className = 'w';
            const i = document.createElement('i');
            i.textContent = tok;
            w.appendChild(i);
            clone.appendChild(w);
          });
          el.appendChild(clone);
        }
      });
    });
  }

  /* ── comparse e barra: un solo giro su scroll, niente osservatori ── */
  const daMostrare = [...document.querySelectorAll(
    '.split, .rule, .riv-grid li, .sc-cols > div, .sc-lenti li, .sc-box li, ' +
    '.sc-numeri li, .sc-chi li, .sc-galleria figure, .sc-split-txt, .sc-split-img, .ct-card, ' +
      '.chi-foto li, .vcard'
  )];

  function giro() {
    const y = scrollY, vh = innerHeight;
    for (let i = daMostrare.length - 1; i >= 0; i--) {
      const r = daMostrare[i].getBoundingClientRect();
      if (r.top < vh * 0.92 && r.bottom > 0) {
        daMostrare[i].classList.add('in');
        daMostrare.splice(i, 1);
      }
    }
    if (bar) {
      const velo = y > 2 ? 1 : 0;
      bar.style.setProperty('--velo', velo);
      bar.classList.toggle('stuck', velo === 1);
    }
    const max = document.documentElement.scrollHeight - vh;
    if (prog) prog.style.width = (max > 0 ? (y / max) * 100 : 0) * 1 + '%';
  }

  addEventListener('scroll', giro, { passive: true });
  addEventListener('resize', giro);
  addEventListener('load', giro);
  giro();
  requestAnimationFrame(() => document.documentElement.classList.add('ready'));
  [120, 400, 900, 1600].forEach((t) => setTimeout(giro, t));




  /* ── salto all'ancora arrivando da un'altra pagina ──
     Con "scroll-behavior: smooth" sul documento il browser a volte non
     completa il salto: ci prova mentre la pagina sta ancora crescendo
     (video e immagini che riservano spazio) e resta in cima. Lo
     rifacciamo a caricamento finito, ma solo se nessuno si è mosso:
     se l'utente ha già iniziato a scorrere non lo strattoniamo. */
  (function ancora() {
    if (!location.hash || location.hash.length < 2) return;
    let fatto = false;
    const vai = () => {
      if (fatto || scrollY > 4) return;
      let el = null;
      try { el = document.querySelector(location.hash); } catch (e) { return; }
      if (!el) return;
      const prima = document.documentElement.style.scrollBehavior;
      document.documentElement.style.scrollBehavior = 'auto';
      el.scrollIntoView();
      document.documentElement.style.scrollBehavior = prima;
      fatto = true;
    };
    addEventListener('load', () => requestAnimationFrame(vai));
    setTimeout(vai, 400);
    setTimeout(vai, 1000);
  })();

  /* ── visore: clic su una foto per ingrandirla, frecce per scorrere ── */
  (function visore() {
    const foto = [...document.querySelectorAll('.chi-foto img, .sc-galleria img')];
    if (!foto.length) return;
    const EN = document.documentElement.lang === 'en';

    const scatola = document.createElement('div');
    scatola.className = 'lbox';
    scatola.setAttribute('role', 'dialog');
    scatola.setAttribute('aria-modal', 'true');
    scatola.innerHTML =
      '<img alt="">' +
      '<button type="button" class="lbox-chiudi" aria-label="' + (EN ? 'Close' : 'Chiudi') + '">×</button>' +
      '<button type="button" class="lbox-prima" aria-label="' + (EN ? 'Previous photo' : 'Foto precedente') + '">‹</button>' +
      '<button type="button" class="lbox-dopo" aria-label="' + (EN ? 'Next photo' : 'Foto successiva') + '">›</button>' +
      '<p class="lbox-conta" aria-hidden="true"></p>';
    document.body.appendChild(scatola);

    const grande = scatola.querySelector('img');
    const conta = scatola.querySelector('.lbox-conta');
    let indice = 0, daRidare = null;

    function mostra(i) {
      indice = (i + foto.length) % foto.length;
      grande.src = foto[indice].currentSrc || foto[indice].src;
      grande.alt = foto[indice].alt || '';
      conta.textContent = (indice + 1) + ' / ' + foto.length;
    }
    function apri(i) {
      daRidare = document.activeElement;
      mostra(i);
      scatola.classList.add('aperto');
      document.documentElement.style.overflow = 'hidden';
      scatola.querySelector('.lbox-chiudi').focus();
    }
    function chiudi() {
      scatola.classList.remove('aperto');
      document.documentElement.style.overflow = '';
      if (daRidare && daRidare.focus) daRidare.focus();
    }

    foto.forEach((img, i) => img.addEventListener('click', () => apri(i)));
    scatola.querySelector('.lbox-chiudi').addEventListener('click', chiudi);
    scatola.querySelector('.lbox-prima').addEventListener('click', () => mostra(indice - 1));
    scatola.querySelector('.lbox-dopo').addEventListener('click', () => mostra(indice + 1));
    scatola.addEventListener('click', (e) => { if (e.target === scatola) chiudi(); });
    addEventListener('keydown', (e) => {
      if (!scatola.classList.contains('aperto')) return;
      if (e.key === 'Escape') chiudi();
      if (e.key === 'ArrowLeft') mostra(indice - 1);
      if (e.key === 'ArrowRight') mostra(indice + 1);
    });
  })();

  /* ── video: partono al tocco del pulsante ── */
  document.querySelectorAll('.video-frame').forEach((frame) => {
    const v = frame.querySelector('video');
    const b = frame.querySelector('.video-play');
    if (!v || !b) return;
    b.addEventListener('click', () => {
      frame.classList.add('playing');
      b.classList.add('off');
      v.controls = true;
      v.play();
    });
  });

  /* I moduli sono gestiti da Shopify: l'invio è un normale POST
     e la risposta arriva ricaricando la pagina. */
})();
